<template>
  <div class="header"
       :style="{ background: 'url(' + require('@/assets/background/' + backgroundName) + ') no-repeat center center fixed'}">
    <div class="inner-header">
      <div class="title">
        <app-navbar/>
        <slot/>
      </div>
    </div>

    <div>
      <svg class="waves"
           xmlns="http://www.w3.org/2000/svg"
           xmlns:xlink="http://www.w3.org/1999/xlink"
           viewBox="0 24 150 28"
           preserveAspectRatio="none"
           shape-rendering="auto">
        <defs>
          <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"/>
        </defs>
        <g class="parallax">
          <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(241,250,231,0.7"/>
          <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(241,250,231,0.5)"/>
          <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(241,250,231,0.3)"/>
          <use xlink:href="#gentle-wave" x="48" y="7" fill="#f1fae7"/>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
  import AppNavbar from '@/components/Navbar'

  export default {
    name: 'AppHeader',
    components: { AppNavbar },
    props: {
      backgroundName: {
        type: String,
        default: 'see_wallpaper.jpg'
      }
    }

  }
</script>

<style lang="scss" scoped>
  h1, h2 {
    margin: 0;
    z-index: 1;
    color: #464646;
    position: relative;
    font-weight: 300;
  }

  h1 {
    font-weight: 700;
    color: $color-green;
    letter-spacing: 2px;
    font-family: 'Delius', cursive;
  }

  h2 {
    font-size: 1.1em;
  }

  .header {
    position: relative;
    text-align: center;
    -webkit-background-size: cover;
    background-size: cover;
    background-color: #f1fae7;
    color: white;

    .inner-header {
      height: 35vh;
      width: 100%;
      margin: 0;
      flex-direction: column;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 2em;

      .title {
        width: 100%;
        position: absolute;
        top: 0;

        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 10em;
          background: #f1fae7;
          border-radius: 0 0 50% 50% / 0 0 100% 100%;
          transform: scaleX(1.2);
        }
      }
    }

    .waves {
      position: relative;
      width: 100%;
      height: 15vh;
      margin-bottom: -7px; /*Fix for safari gap*/
      min-height: 100px;
      max-height: 150px;
    }
  }

  .parallax > use {
    animation: move-forever 25s cubic-bezier(.55, .5, .45, .5) infinite;
  }

  .parallax > use:nth-child(1) {
    animation-delay: -2s;
    animation-duration: 7s;
  }

  .parallax > use:nth-child(2) {
    animation-delay: -3s;
    animation-duration: 10s;
  }

  .parallax > use:nth-child(3) {
    animation-delay: -4s;
    animation-duration: 13s;
  }

  .parallax > use:nth-child(4) {
    animation-delay: -5s;
    animation-duration: 20s;
  }

  @keyframes move-forever {
    0% {
      transform: translate3d(-90px, 0, 0);
    }
    100% {
      transform: translate3d(85px, 0, 0);
    }
  }

  @media (max-width: 768px) {
    .waves {
      height: 40px;
      min-height: 40px;
    }
    h1 {
      font-size: 24px;
    }
  }
</style>
